import React from 'react';
// import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import InitiativeTrackerComponent from './Component/InitiativeTrakerComponent';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ImportdataComponent from './Component/ImportdataComponent';
import AllSpellsComponent from './Component/Database/Spells/SpellListComponent';
import NavbarComponent from './Component/NavbarComponent';
import SourceListComponent from './Component/Database/Sources/SourceListComponent';
import MonsterListComponent from './Component/Database/Monsters/MonsterListComponent';
import EditModeProvider from './Context/EditModeContext';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <EditModeProvider>
          <header className="App-header">
            <NavbarComponent/>
          </header>
          <div className="main-layout">
              <Routes>
                <Route path="/" Component={InitiativeTrackerComponent} />
                <Route path="/initiativetracker" Component={InitiativeTrackerComponent} />
                <Route path="/importdata" Component={ImportdataComponent} />
                <Route path="/spells" Component={AllSpellsComponent} />
                <Route path="/sources" Component={SourceListComponent} />
                <Route path="/monsters" Component={MonsterListComponent} />
              </Routes>
          </div>
        </EditModeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
